import { useQuery } from "@tanstack/react-query";
import {
	dashboardService,
	DashboardSowsProgressionFilters,
} from "../../services/dashboard.service";

const canonicalize = (ids: string[] | undefined): string =>
	[...(ids ?? [])].sort().join(",");

const useSowsProgression = (filters: DashboardSowsProgressionFilters) => {
	const enabled = Boolean(filters.accountId && filters.programId);

	return useQuery({
		queryKey: [
			"dashboard-sows-progression",
			filters.accountId,
			filters.programId,
			canonicalize(filters.orgUnitIds),
			filters.providerId ?? "",
		],
		queryFn: () => dashboardService.getSowsProgression(filters),
		enabled,
		staleTime: 1000 * 60 * 5,
	});
};

export default useSowsProgression;
